module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "content-fm",
    attrs: {
      "id": "calibre_toc_3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTOCAnchor-2"
    }
  }), _c('a', {
    attrs: {
      "id": "b1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/NGJobHacks_split_004#a1"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_c('span', {
    staticClass: "char-style-overridex"
  }, [_vm._v("I")]), _vm._v("n the summer of 2009, I celebrated my 21st birthday the same way any college student hopes to: with a stupid amount of binge drinking. It was an epic four night marathon of drinking with friends. One month later, I finished my last classes for my Bachelor’s of Psychology and Social Behavior. I had accomplished what every young adult hopes to accomplish: getting a college education. Then I realized what every young adult realizes after graduation: I’ve learned nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("My grades for my last classes were Bs. I hadn’t read a single book that quarter. I just skimmed the books before the exams and chose the multiple choice answer that made the most sense. I hadn’t completed a reading assignment since my sophomore year. Usually, after the first midterm I could predict what the professor was going to put on the exam. Good enough to get a GPA above 3.0.")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("I constantly got reminders to reserve my cap and gown for graduation. Celebrations are for real achievements, so I didn’t walk. A couple months later, my classmates messaged me asking what classes I was taking for the Fall semester. Nobody knew I graduated except for my parents. ")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("I was lost. The resources online were inadequate (they still are), and every college adviser I visited made me feel more lost. My parents gave me the typical career advice: Healthcare or Engineering. None of the advice I got made sense, and most of it was outdated, which is why I’m writing this book"), _c('span', [_vm._v("– ")]), _vm._v("to be the first handbook that gives realistic career advice that is supported with data and proof.")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("Now it’s the winter of 2015. I currently work as the main content creator for "), _c('a', {
    attrs: {
      "href": "http://Chameleon.LA",
      "target": "_blank"
    }
  }, [_vm._v("Chameleon.LA")]), _vm._v(", one of the best growth hacking & social media management companies in Los Angeles. I create memes (a piece of media that is shareable) for big YouTubers and companies. One of my clients is Bro Science Life, a YouTube channel that currently has 1.5 million subscribers. I made viral internet memes for "), _c('a', {
    attrs: {
      "href": "http://www.Uproxx.com",
      "target": "_blank"
    }
  }, [_vm._v("Uproxx.com")]), _vm._v(", which regularly got 10 million+ views. Before I stepped into the media world, I got a degree in mechanical engineering and worked as an engineer in three different industries: natural gas, oil, and HVAC.")]), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }), _vm._v(" "), _c('p', {
    staticClass: "chapsoy-title"
  }, [_vm._v("While getting fired from all three jobs, I created the most popular career channel on YouTube: Engineered Truth. I currently have 60,000 subscribers that rely on me for career information that they can’t get anywhere else. Now I’m going to share with you how to get your first real job– and no, you don’t have to become an engineer, doctor or lawyer.")]), _vm._v(" "), _c('p', {
    staticClass: "structure-next",
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "NGJobHacks-16_fmt.png",
      "src": "OEBPS/image/NGJobHacks-16_fmt.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-762ca5f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/NGJobHacks_split_005.vue
// module id = 72
// module chunks = 0